import React from "react";
import { useSelector } from "react-redux";
import MovieList from "./MovieList";
import ShimmerGptSearch from "./ShimmerGptSearch";

const GptMovieRecommendations = () => {
	const { movieResults, loading } = useSelector((store) => store.gpt);

	if (movieResults && movieResults.length === 0)
		return (
			<div className="bg-black p-4 relative z-[1] mt-[50px] text-center">
				<h4 className="text-base lg:text-2xl 2xl:text-3xl text-white">
					No movies found! Please try something else.
				</h4>
			</div>
		);

	if (null == movieResults) return;

	return (
		<div className="movie-recommendations overflow-y-visible relative z-0 bg-opacity-80 bg-black mt-[50px] py-[20px] px-4">
			<MovieList
				title="Suggested Movies"
				movies={movieResults}
				isGptMovies={true}
			/>
		</div>
	);
};

export default GptMovieRecommendations;
